import React from 'react'

const Slack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 210">
    <path
      fill="#4A4A4A"
      fillRule="evenodd"
      d="M179.9 143.933c-.003 5.525-3.877 12.24-8.66 15l-67.653 39.06c-4.78 2.76-12.536 2.758-17.32 0l-67.56-38.945c-4.787-2.76-8.664-9.477-8.66-15l.052-77.98c0-5.526 3.87-12.24 8.66-15l67.65-39.06c4.78-2.76 12.53-2.76 17.32 0l67.56 38.944c4.78 2.76 8.66 9.477 8.66 15l-.05 77.98zm-35.188-24.745l.067.233c4.78-1.55 7.41-6.78 5.78-11.67-1.62-4.89-6.85-7.44-11.69-5.89l-11.51 3.83-7.69-22.86 11.554-3.89c4.82-1.6 7.437-6.82 5.822-11.67-1.627-4.78-6.86-7.4-11.69-5.78l-11.544 3.77-4.01-12c-1.603-4.865-6.847-7.422-11.69-5.865-4.855 1.66-7.416 6.89-5.857 11.67l4.007 11.89-23.702 7.96-4.01-11.92c-1.56-4.8-6.79-7.437-11.69-5.8-4.9 1.6-7.46 6.82-5.9 11.67l4 11.89L43.4 88.6c-4.897 1.633-7.457 6.857-5.9 11.67 1.226 3.78 4.79 6.17 8.463 6.28 1.058.023 2.127-.12 3.173-.478l11.512-3.89 7.337 22.888-11.58 3.89c-4.787 1.557-7.46 6.78-5.79 11.67 1.337 3.78 4.788 6.227 8.574 6.338 1.11 0 2.11-.11 3.23-.445L74 142.63l4.008 12.004c1.336 3.78 4.787 6.18 8.573 6.292 1.12.022 2.12-.123 3.23-.478 4.9-1.612 7.46-6.836 5.9-11.67L91.7 136.86l23.83-7.957 4.01 11.916c1.334 3.78 4.785 6.18 8.57 6.29 1.114.03 2.116-.14 3.23-.47 4.83-1.62 7.45-6.85 5.834-11.67l-4.01-11.93 11.547-3.86zM79.05 96.874v.123l23.434-8.07 7.566 22.976-23.434 8.025-7.566-23.054z"
    />
  </svg>
)

export default Slack



// WEBPACK FOOTER //
// ./src/Slack.js